import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, Box, Grid2, IconButton, Stack } from '@mui/material';
import Carousel from 'react-multi-carousel';
import Game from './Game';

const GameList = ({ games, currentUser, cancelGame, useCarousel = false, useGrid = false }) => {
  const navigate = useNavigate();

  const GameBox = ({ game }) => {
    return (
      <Box sx={{ width: { xs: 'calc(100vw - 96px)', sm: '326px' } }}>
        <Game data={game}></Game>
        {game.createdBy.id === currentUser.uid && game.active && (
          <>
            <Button
              variant="gameDelete"
              color="error"
              size="small"
              onClick={() => {
                cancelGame(game);
              }}
            >
              Cancel Game
            </Button>
            <Button
              variant="gameInvite"
              color="primary"
              size="small"
              onClick={() => {
                navigate(`/games/${game.id}/invite`);
              }}
            >
              Invite
            </Button>
          </>
        )}
      </Box>
    );
  };

  const ButtonGroup = ({ next, previous, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <Box
        className="carousel-button-group"
        sx={{ position: 'absolute', bottom: 'unset', top: { xs: '-30px', sm: '-42px' }, right: 0 }}
      >
        <IconButton aria-label="previous" disabled={currentSlide === 0} onClick={() => previous()}>
          <ArrowBackIcon fontSize="large" />
        </IconButton>
        <IconButton
          aria-label="next"
          disabled={currentSlide === games.length - 1}
          onClick={() => next()}
        >
          <ArrowForwardIcon fontSize="large" />
        </IconButton>
      </Box>
    );
  };

  const carouselResponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 2,
      //partialVisibilityGutter: CARD_WIDTH / 2 + CARD_PADDING
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2,
      //partialVisibilityGutter: CARD_WIDTH / 2 + CARD_PADDING
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const carouselRef = useRef(null);

  if (useCarousel) {
    const extraSlidesLength = Math.floor(games.length / 3);
    const extraSlides = [];
    for (var i = 0; i < extraSlidesLength; i++) {
      extraSlides.push(
        <Box
          className="extra_slide"
          key={`emptySlide-${i}`}
          sx={{ mr: 2, width: { xs: '100vw', md: 'unset' }, minWidth: '326px' }}
        ></Box>
      );
    }

    return (
      <Box sx={{ position: 'relative', width: '100%', height: '455px' }}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: { xs: 'calc(100vw - 48px)', md: 'calc(75vw - 48px)' },
            maxWidth: '1012px',
          }}
        >
          <Carousel
            ref={carouselRef}
            responsive={carouselResponsive}
            showDots={false}
            keyBoardControl={true}
            arrows={false}
            swipeable
            draggable
            renderArrowsWhenDisabled
            renderButtonGroupOutside={true}
            customButtonGroup={<ButtonGroup />}
          >
            {games.map((game, index) => (
              <Box sx={{ mr: 2 }} key={`gameSlide-${index}`}>
                <Game key={game.id} data={game} />
              </Box>
            ))}
            {extraSlides}
          </Carousel>
        </Box>
      </Box>
    );
  }
  if (useGrid) {
    return (
      <Grid2 container spacing={2}>
        {games.map((game) => (
          <Grid2
            item
            size={{ xs: 12, sm: 6, lg: 4 }}
            key={game.id}
            sx={{ position: 'relative', marginBottom: '16px' }}
          >
            <GameBox game={game} />
          </Grid2>
        ))}
      </Grid2>
    );
  }
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
      {games.map((game, index) => (
        <GameBox game={game} key={`gameBox-${index}`} />
      ))}
    </Stack>
  );
};

export default GameList;
